import React from "react";
import styled from "styled-components";
import { createForm } from "modules/form";
import createFormActions from "modules/form/actions";
import store from "services/store";
import { createUser } from "state/game/actions";
import { ShallowButton } from "components/ui/Button";
import Fields from "components/ui/Fields";
import Validator from "services/validator";
import { EmailType, Missing } from "services/validator/rules";

const FormWrap = styled.div`
  width: 400px;
  margin-left: 64px;

  input.ant-input {
    background-color: transparent;
    border: 1px solid #fff;
    box-shadow: 0px 5px 10px rgba(68, 50, 245, 0.1);
    border-radius: 4px;
    color: #fff;
    :hover {
      background-color: transparent;
    }
  }

  .ant-checkbox-wrapper {
    color: #fff;
  }

  label {
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.2px;
  }
`;

const validator = new Validator();

validator.addRule(["fullName", "nickname", "email", "company"], Missing());
validator.addRule(["email"], EmailType());

const formActions = createFormActions({
  validator,
  async init() {
    return {
      email: "",
      fullName: "",
      nickname: "",
      company: "",
    };
  },
  async submit(data) {
    store.dispatch(createUser(data));
  },
});

function RegisterFields({ onSubmit }) {
  return (
    <FormWrap>
      <Fields.Input name="fullName" data-qa="fullName" label="Full Name" />
      <Fields.Input name="nickname" data-qa="nickame" label="Nickname" />
      <Fields.Input
        name="email"
        data-qa="email"
        autoComplete="username"
        label="Email"
      />
      <Fields.Input
        name="company"
        data-qa="company"
        autoComplete="company"
        label="Company"
        submitOnEnter
      />
      <ShallowButton
        color="#AF26FA"
        size="large"
        data-qa="submit"
        onClick={onSubmit}
      >
        Game on
      </ShallowButton>
    </FormWrap>
  );
}

const RegisterForm = createForm({
  Component: RegisterFields,
  actions: formActions,
});

export default RegisterForm;
